<template>
  <div class="warp">
    <!-- 头部工具栏 -->
    <div class="company_heard_tool">
      <el-button type="primary" size="mini" icon="el-icon-plus" @click="openDialog('添加广告')">添加</el-button>
      <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteGroup">批量删除</el-button>
      <el-button type="warning" size="mini" icon="el-icon-refresh" @click="refresh">刷新</el-button>
    </div>
    <div ref="tableWrap" style="flex: 1">
      <el-table
        v-if="tableH"
        ref="table"
        v-loading="loading"
        :max-height="tableH - 47"
        :data="tableData"
        :stripe="true"
        :border="true"
        size="mini"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column label="图片" width="140">
          <template slot-scope="scope">
            <el-image :src="scope.row.image" style="width: 108px; height: 60px" @click="previewImage(scope.row.image)" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="位置">
          <template slot-scope="scope">
            <span v-if="scope.row.position === 1">用户端首页</span>
            <span v-if="scope.row.position === 2">企业端首页</span>
          </template>
        </el-table-column>
        <el-table-column label="类型">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">跳转链接</span>
            <span v-if="scope.row.type === 2">跳转内页</span>
            <span v-if="scope.row.type === 3">不跳转</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="orders" width="50" />
        <el-table-column label="链接" prop="path" width="160" />
        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.isPublished" style="color: #67c23a">发布中</span>
            <span v-else style="color: #909399">已下架</span>
          </template>
        </el-table-column>
        <el-table-column label="创建日期" prop="createDate" width="200" />
        <el-table-column prop="address" label="操作" width="160">
          <template slot-scope="scope">
            <div style="display: flex">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="openDialog('编辑广告', scope.row)">编辑</el-button>
              <el-button type="danger" size="mini" icon="el-icon-delete" style="margin-left: 10px" @click="handleDeleteCategory(scope.row)">删除</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div style="padding: 15px 0 0">
        <el-pagination
          :current-page="page.pageNumber"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.pageSize"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- 添加 编辑对话框 -->
    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="showDialog" width="500px" append-to-body @close="resetForm">
      <el-form ref="form" label-position="left" :rules="rules" style="margin: 20px 0" :model="form" label-width="80px">
        <el-form-item prop="image" label-width="100px" label="图片：">
          <el-upload
            class="avatar-uploader"
            action="/api/admin/file/upload"
            :on-success="handleImageSuccess"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="form.image" :src="form.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item prop="position" label-width="100px" label="位置：">
          <el-radio-group v-model="form.position">
            <el-radio :label="1">用户端首页</el-radio>
            <el-radio :label="2">企业端首页</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="type" label-width="100px" label="类型：">
          <el-radio-group v-model="form.type" @change="(e) => (e === 2 ? (form.path = '/pages/job-detail/job-detail?sn=') : e === 3 ? (form.path = '-') : (form.path = null))">
            <el-radio :label="1">跳转链接</el-radio>
            <el-radio :label="2">跳转内页</el-radio>
            <el-radio :label="3">不跳转</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-show="form.type !== 3" prop="path" label-width="100px" label="链接：">
          <el-input v-model="form.path" />
        </el-form-item>
        <el-form-item prop="orders" label-width="100px" label="排序：">
          <el-input v-model="form.orders" style="max-width: 80px" type="number" class="number-input" />
        </el-form-item>
        <el-form-item prop="isPublished" label-width="100px" label="状态：">
          <el-radio-group v-model="form.isPublished">
            <el-radio :label="1">发布中</el-radio>
            <el-radio :label="0">已下架</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showDialog = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit(dialogTitle === '添加企业')">提交</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="previewImageDialog">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
// import { deepClone } from '@/utils'
export default {
  data() {
    return {
      tableData: [],
      loading: true,
      showDialog: false,
      dialogTitle: '',
      form: {
        image: null,
        isPublished: null,
        path: 'null',
        position: null,
        type: null,
        path: null,
        orders: null
      },
      rules: {
        image: [{ required: true, message: '请上传广告图片', trigger: 'change' }],
        isPublished: [{ required: true, message: '请选择状态', trigger: 'change' }],
        path: [{ required: true, message: '不能为空', trigger: 'blur' }],
        orders: [{ required: true, message: '不能为空', trigger: 'blur' }],
        position: [{ required: true, message: '请选择广告位置', trigger: 'change' }],
        type: [{ required: true, message: '请选择广告类型', trigger: 'change' }]
      },
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      total: 0,
      ids: {},
      tableH: 0
    }
  },

  mounted() {
    this.getTableList()
    this.tableH = this.$refs.tableWrap.clientHeight
  },
  methods: {
    getTableList() {
      this.loading = true
      return this.$api.operation
        .reqAdList(this.page)
        .then((res) => {
          this.tableData = res.records
          this.total = res.total
          this.loading = false
        })
        .catch(() => {})
    },
    openDialog(title, row) {
      this.dialogTitle = title
      this.showDialog = true
      if (!row) return
      this.$nextTick(() => {
        let isPublished = row.isPublished
        const { image, path, position, type, orders, id } = row
        isPublished = isPublished ? 1 : 0
        this.form = { image, isPublished, path, position, type, orders, id }
      })
    },
    handleSubmit(isAdd) {
      if (!this.validateForm()) return
      const data = Object.assign({}, this.form)
      data.isPublished = Boolean(data.isPublished)
      if (this.dialogTitle === '添加广告') {
        this.loading = true
        this.$api.operation
          .reqAddAd(data)
          .then((res) => {
            this.$message.success(res)
            this.getTableList()
          })
          .catch((e) => {
            this.$message.error(e)
          })
      } else {
        this.loading = true
        this.$api.operation
          .reqUpdateAd(data)
          .then((res) => {
            this.$message.success(res)
            this.getTableList()
          })
          .catch((e) => {
            this.$message.error(e)
          })
      }
      this.showDialog = false
      this.loading = true
    },
    handleSelectionChange(e) {
      this.ids = e.map((item) => item.id)
    },
    deleteGroup() {
      if (!this.ids.length) return this.$message.info('当前无选中项')
      this.$confirm('此操作将永久删除该广告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$api.operation
            .reqDeleteAd({ ids: this.ids.join(',') })
            .then((res) => {
              this.$message.success('操作成功')
              this.getTableList()
            })
            .catch((e) => {
              this.$message.error(e)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },

    handleDeleteCategory(row) {
      this.$confirm('此操作将永久删除该广告, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$api.operation
            .reqDeleteAd({ ids: row.id })
            .then((res) => {
              this.$message({
                type: 'success',
                message: res
              })
              this.loading = true
              this.getTableList()
            })
            .catch((e) => {
              this.$message({
                type: 'info',
                message: e
              })
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    beforeAvatarUpload(file) {
      const isImg = /image/.test(file.type)
      if (!isImg) {
        this.$message.error('只能上传图片!')
      }
      return isImg
    },
    handleImageSuccess(res) {
      this.$refs.form.clearValidate('image')
      this.form.image = res.data
    },
    validateForm() {
      let pass
      this.$refs.form.validate((res) => {
        pass = res
      })
      return pass
    },
    resetForm() {
      this.$refs.form.resetFields()
    },
    handleCurrentChange(e) {
      this.page.pageNumber = e
      this.getTableList()
    },
    handleSizeChange(e) {
      this.page.pageSize = e
      this.getTableList()
    },
    refresh() {
      this.page = {
        pageNumber: 1,
        pageSize: 10
      }
      Promise.all([this.getTableList()])
        .then((res) => {
          this.$message.success('刷新成功')
        })
        .catch(() => {
          this.$message.error('刷新成功')
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.warp {
  font-size: 14px;
  padding: 20px;
  box-sizing: border-box;
  height: calc(100vh - 84px);
  display: flex;
  flex-direction: column;
  .company_heard_tool {
    margin-bottom: 10px;
  }
}
</style>
